(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["videoslide"] && !window.DesignMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const video = document.getElementById("hurabg-video");
  const button = document.getElementById("unmute-btn");

  if(video && button) {
    // Button click event
    button.addEventListener("click", function() {
      video.muted = false;
      video.play().catch(() => {
        // Browser blocked autoplay with sound
        button.style.display = "block";
      });
      button.style.display = "none"; // hide if success
    });

    // Auto trigger after page load
    setTimeout(() => {
      button.click();
    }, 1000); // 1s delay ensures video element is ready
  }
});

  } catch(e) { console.error(e); }
})();
})();
